import { render, staticRenderFns } from "./cardBtn.vue?vue&type=template&id=1c973810&scoped=true"
import script from "./cardBtn.ts?vue&type=script&lang=ts&external"
export * from "./cardBtn.ts?vue&type=script&lang=ts&external"
import style0 from "./cardBtn.vue?vue&type=style&index=0&id=1c973810&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c973810",
  null
  
)

export default component.exports